const hamburger = document.querySelector('.btn-hamburger');
const searchSection = document.querySelector('.main-header__search-button');
const searchSectionContainer = document.querySelector(
	'.main-header__search-container'
);
const searchSectionClose = document.querySelector('.search-field__close');
const menuButtons = document.querySelectorAll(
	'.block-primary-nav-item > .wp-block-button:not(:only-child) .wp-block-button__link'
);
const megaMenus = document.querySelectorAll(
	'.block-primary-nav-mega-menu__inner'
);

const closeSubmenus = (delay = false, currentButton = null) => {
	menuButtons.forEach((menuButton) => {
		if (
			!currentButton ||
			!currentButton.parentElement.classList.contains('active') ||
			currentButton.parentElement !== menuButton.parentElement
		) {
			menuButton.parentElement.classList.remove('active');
		}
	});

	if (
		null === currentButton ||
		!currentButton.parentElement.classList.contains('active')
	) {
		if (true === delay) {
			setTimeout(function () {
				document.body.classList.remove('primary-submenu-open');
			}, 400);
		} else {
			document.body.classList.remove('primary-submenu-open');
		}
	}
};
const clickOffMenu = (e) => {
	if (
		(e.key === undefined &&
			!hamburger.contains(e.target) &&
			!searchSection.contains(e.target) &&
			!e.target.classList.contains('wp-block-button__link')) ||
		e.key === 'Escape'
	) {
		if (window.innerWidth >= 992) {
			document.body.classList.remove('primary-submenu-visible');
			document.body.classList.remove('overlayed');
			closeSubmenus();
			document.removeEventListener('keydown', clickOffMenu);
			document.removeEventListener('click', clickOffMenu);
			setMenuPosition();
		}
	} else if (
		e.key === undefined &&
		(hamburger.contains(e.target) || searchSection.contains(e.target)) &&
		!e.target.classList.contains('wp-block-button__link')
	) {
		document.body.classList.remove('primary-submenu-visible');
		closeSubmenus();
		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);
		setMenuPosition();
	}
};
const setMenuPosition = (target = null) => {
	if (window.innerWidth < 992) {
		return;
	}

	let megaMenuContent;
	//console.log('target: ' + target);
	if (target) {
		megaMenuContent = target.parentElement.parentElement.querySelector(
			'.block-primary-nav-mega-menu__content'
		);
		//console.log('megaMenuContent: ' + megaMenuContent);
	}

	if (megaMenuContent) {
		document.body.classList.add('mega-menu-init');
		megaMenuContent.style.removeProperty('--menuOffset');

		const button = target.parentElement;
		let menuContentRect = megaMenuContent.getBoundingClientRect();
		const buttonRect = button.getBoundingClientRect();
		const megaMenuRect =
			megaMenuContent.parentElement.getBoundingClientRect();
		let offset;
		//console.log('menuContentRect.left: ' + menuContentRect.left);
		//console.log('buttonRect.left: ' + buttonRect.left);
		//console.log('menuContentRect.right: ' + menuContentRect.right);
		//console.log('window: ' + window.scrollX);
		if (menuContentRect.left > buttonRect.left) {
			offset =
				buttonRect.left -
				menuContentRect.left +
				button.offsetWidth / 2 -
				megaMenuContent.offsetWidth / 2;

			if (menuContentRect.left + offset < megaMenuRect.left) {
				offset = megaMenuRect.left - menuContentRect.left;
			}
		}
		// else if (menuContentRect.right < buttonRect.left) {
		// 	offset =
		// 		buttonRect.right -
		// 		menuContentRect.right -
		// 		button.offsetWidth / 2 +
		// 		megaMenuContent.offsetWidth / 2;

		// 	if (menuContentRect.right + offset > megaMenuRect.right) {
		// 		offset = megaMenuRect.right - menuContentRect.right;
		// 		console.log('offset right');
		// 	}
		// 	console.log('right greater left');
		// }
		else if (
			menuContentRect.left < buttonRect.left &&
			menuContentRect.right > buttonRect.left
		) {
			// if (window.innerWidth > 1400) {
			offset = buttonRect.left - menuContentRect.left - 48;
			// } else {
			// 	offset = buttonRect.left - menuContentRect.left - 148;
			// }
		} else {
			// if (window.innerWidth > 1400) {
			offset = buttonRect.left - menuContentRect.left - 48;
			// } else {
			// 	offset = buttonRect.left - menuContentRect.left - 148;
			// }
		}
		if (offset) {
			megaMenuContent.style.setProperty(
				'--menuOffset',
				`${offset / 16}rem`
			);
			menuContentRect = megaMenuContent.getBoundingClientRect();
		}

		document.documentElement.style.setProperty(
			'--openMenuLeft',
			`${menuContentRect.left / 16}rem`
		);

		document.documentElement.style.setProperty(
			'--openMenuWidth',
			`${megaMenuContent.offsetWidth}`
		);

		document.documentElement.style.setProperty(
			'--openMenuBottom',
			`${
				(megaMenuContent.offsetTop +
					megaMenuContent.offsetHeight +
					64) /
				16
			}rem`
		);

		document.body.classList.remove('mega-menu-init');
	}
};

const toggleSubmenu = (e) => {
	e.preventDefault();
	e.currentTarget.parentElement.classList.toggle('active');

	// close other sub menus
	closeSubmenus(false, e.currentTarget);

	if (!e.currentTarget.parentElement.classList.contains('active')) {
		document.body.classList.remove('primary-submenu-open');
		document.body.classList.remove('primary-submenu-visible');
		document.body.classList.remove('overlayed');
		document.removeEventListener('keydown', clickOffMenu);
		document.removeEventListener('click', clickOffMenu);

		setMenuPosition();
	} else {
		document.body.classList.add('primary-submenu-open');
		document.body.classList.add('overlayed');
		document.addEventListener('keydown', clickOffMenu);
		document.addEventListener('click', clickOffMenu);

		setMenuPosition(e.currentTarget);

		setTimeout(function () {
			document.body.classList.add('primary-submenu-visible');
		}, 400);
	}
};
const addMegaMenuClasses = () => {
	megaMenus.forEach((megaMenu) => {
		const content = megaMenu.querySelector(
			'.block-primary-nav-mega-menu__content'
		);

		if (content && content.children) {
			let megaMenuGridTemplateColumns = '';
			let columnCount = 0;

			Object.values(content.children).forEach((child) => {
				if (child.classList.contains('block-primary-nav-column')) {
					megaMenuGridTemplateColumns += ' minmax(MINVALUE, 1fr)';
					columnCount++;
				} else if (
					child.classList.contains('block-primary-nav-featured-page')
				) {
					megaMenuGridTemplateColumns += ' auto';
				}
			});

			let minValue = '19rem';
			let megaMenuClass = '';

			if (columnCount > 2) {
				minValue = '12rem';
				megaMenuClass = 'block-primary-nav-mega-menu--wide';
			} else if (columnCount > 1) {
				minValue = '15rem';
			}

			megaMenuGridTemplateColumns =
				megaMenuGridTemplateColumns.replaceAll('MINVALUE', minValue);

			megaMenu.style.setProperty(
				'--gridTemplateColumns',
				`${megaMenuGridTemplateColumns}`
			);

			megaMenu.style.setProperty('--columnCount', `${columnCount}`);

			if (megaMenuClass) {
				megaMenu.classList.add(megaMenuClass);
			}
		}
	});
};
const clickOffSearch = (e) => {
	if (
		e.key === undefined &&
		!searchSectionContainer.contains(e.target) &&
		!searchSection.contains(e.target)
	) {
		closeSearch();
		if (
			!e.target.classList.contains('wp-block-button__link') &&
			!hamburger.contains(e.target)
		) {
			document.body.classList.remove('overlayed');
			document.body.classList.remove('lock-scroll');
		}
	} else if (e.key === 'Escape') {
		closeSearch();
		document.body.classList.remove('overlayed');
		document.body.classList.remove('lock-scroll');
	}
};
const closeSearch = () => {
	searchSectionContainer.classList.remove('active');
	document.removeEventListener('keydown', clickOffSearch);
	document.removeEventListener('click', clickOffSearch);
};
const toggleSearch = (e) => {
	e.preventDefault();

	searchSectionContainer.classList.toggle('active');

	if (!searchSectionContainer.classList.contains('active')) {
		document.body.classList.remove('overlayed');
		document.body.classList.remove('lock-scroll');
		document.removeEventListener('keydown', clickOffSearch);
		document.removeEventListener('click', clickOffSearch);
	} else {
		document.body.classList.add('overlayed');
		document.body.classList.add('lock-scroll');
		document.addEventListener('keydown', clickOffSearch);
		document.addEventListener('click', clickOffSearch);
	}
};
// GLOBAL APP CONTROLLER
const controller = {
	init() {
		menuButtons.forEach((menuButton) => {
			menuButton.addEventListener('click', toggleSubmenu);
		});

		searchSection.addEventListener('click', toggleSearch);
		searchSectionClose.addEventListener('click', toggleSearch);

		if (megaMenus.length) {
			addMegaMenuClasses();
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
